import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../../structure/row';
import { Cell, LEFT, RIGHT } from '../../structure/cell';
import { FormattedPrice } from '../../../price/formatted_price';
import getTranslatedText from '../../../../helper/get_translated_text';
import CartActions from '../../../../actions/cart_actions';
import Translation from '../../../translation/translation';

export function ProductDiscount(props) {
  const isNRMA = TYROOLA.globals.store === 'AU_NRMA';
  const { voucherData } = TYROOLA.initialFluxStates;
  return (
    <>
      <Row
        className={`sidebar__row--discount discount discount--buy-4-pay-3 ${
          !props.discountName ? 'sidebar__row--no-padding-bottom' : ''
        }`}
      >
        <Cell side={LEFT}>
          {!voucherData && (
            <div className={`discount__name ${props.type === 'price' ? 'text-blue' : ''}`}>{props.discountName}</div>
          )}
        </Cell>
        <Cell side={RIGHT}></Cell>
        <Cell side={RIGHT}>
          {!voucherData && props.discountAmount !== '' && (
            <FormattedPrice
              price={props.discountAmount}
              currencyIsoCode={props.currencyIsoCode}
              className="discount__price"
              inCents={true}
            />
          )}
        </Cell>
      </Row>
      {voucherData &&
        voucherData.allDiscounts &&
        voucherData.allDiscounts.map((d) => (
          <Row key={d.idVoucher} className="sidebar__row--discount discount discount--voucher sidebar__row--no-border">
            <Cell side={LEFT}>
              <div className={`discount__name text-blue`}>{d.name}</div>
            </Cell>
            <Cell side={RIGHT}></Cell>
            <Cell side={RIGHT}>
              {d.amount !== '' && (
                <FormattedPrice
                  price={d.amount}
                  currencyIsoCode={props.currencyIsoCode}
                  className="discount__price"
                  inCents={true}
                />
              )}
            </Cell>
          </Row>
        ))}
      <tr className="discount--buy-4-pay-3">
        <td className="col-xs-12 voucher-sidebar-style" colSpan="3" style={{ padding: '0' }}>
          <a
            href="javascript:void(0);"
            className={`${isNRMA ? 'sidebar-voucher-code-nrma' : ''} sidebar-voucher-code cursor-pointer`}
            style={{ marginTop: voucherData ? '15px' : '0' }}
            onClick={(e) => CartActions.onClickVoucherCodeLink(e)}
          >
            <Translation translationKey={'checkout-sidebar-voucher-code-text'} />
          </a>
        </td>
      </tr>
    </>
  );
}

ProductDiscount.propTypes = {
  discountAmount: PropTypes.number.isRequired,
  discountName: PropTypes.string.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
};
